module.exports = __webpack_public_path__ + "static/media/no-image.f493c75e.svg";